import { render, staticRenderFns } from "./MonitoringVersion.vue?vue&type=template&id=fa1b5a5e&scoped=true"
import script from "./MonitoringVersion.vue?vue&type=script&lang=js"
export * from "./MonitoringVersion.vue?vue&type=script&lang=js"
import style0 from "./MonitoringVersion.vue?vue&type=style&index=0&id=fa1b5a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1b5a5e",
  null
  
)

export default component.exports